import {Controller} from "stimulus"
import $ from 'jquery';
import {get} from '@rails/request.js'
import flatpickr from "flatpickr";
import {create_array_for_product} from "./b2b_controller";


export default class extends Controller {
    static targets = ["destinationsSelect", "howFindAboutEvent", "howFindAboutEventOtro"]

    connect() {
    }

    initialize() {
        /* Escuchar el evento change para detectar cuando se quita 'Otros' */
        $('#accreditation_food_preferences').on('change', (e) => {
            this.show_otro_multiple(e);
        });
    }

    /* Para cuando se da click pero estas sin loguear */
    isLogin(r) {
        if (r.responseText && typeof r.responseText.then === 'function') {
            r.responseText.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        }
        if (r.response && typeof r.response.then === 'function') {
            r.response.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        } else {
            if (r.response.url.includes("login")) {
                window.location.href = r.response.url;
            }
        }
    }

    validate_emails(e) {
        let value = $.trim(e.target.value);

        let emails = value.split(',').map((email) => {
            return $.trim(email);
        }).filter((email) => {
            return email !== '';
        });

        let many_emails_accred = false;
        if (e.target.dataset.hasOwnProperty('countemails')) {
            if (emails.length > parseInt(e.target.dataset.countemails)) {
                many_emails_accred = true;
            }
        }

        // Verificar si hay correos repetidos
        let uniqueEmails = [...new Set(emails)];
        let repeatedEmails = emails.length !== uniqueEmails.length;
        let repeatedEmailsText = '';
        if (repeatedEmails) {
            repeatedEmailsText = 'No se permiten correos electrónicos repetidos. <br>';
        }

        let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        let helper_email_error = [];
        let isValid_emails = [];
        emails.map(email => {
            if (emailRegex.test(email)) {
                isValid_emails.push(true);
            } else {
                helper_email_error.push(email);
                isValid_emails.push(false);
            }
        })
        /*let isValid = emails.every(function (email) {
            if (emailRegex.test(email)) {
                return true;
            } else {
                helper_email_error.push(email);
                return false;
            }

        });*/

        let isValid = isValid_emails.every(valor => {
            return valor === true;
        })

        let messages = [];
        if (repeatedEmails) {
            messages.push('No se permiten correos electrónicos repetidos.');
        }
        if (many_emails_accred) {
            messages.push(`Solo puedes poner ${e.target.dataset.countemails} correos electrónicos.`);
        }
        if (!isValid) {
            messages.push(`Correos que no cumplen con los requisitos: ${helper_email_error.join(', ')}`);
        }

        if (messages.length > 0) {
            $(`#${e.target.dataset.validate}`).attr('disabled', 'disabled');
            e.target.classList.add('is-invalid');
            $(`#${e.target.dataset.helper}`).html(messages.join('<br>'));
        } else {
            $(`#${e.target.dataset.validate}`).removeAttr('disabled');
            e.target.classList.remove('is-invalid');
            $(`#${e.target.dataset.helper}`).text('');
            helper_email_error = [];
        }
    }

    validate_date(e) {
        let value = $.trim(e.target.value);

        if (value === '') {
            $(`#${e.target.dataset.validate}`).attr('disabled', 'disabled')
        } else {
            $(`#${e.target.dataset.validate}`).removeAttr('disabled')
        }
    }

    show_otro(e) {
        let value = e.target.value;
        if (e.target.dataset.hasOwnProperty('otro')) {
            if (value === 'Otros') {
                $(`#${e.target.dataset.otro}`).removeClass('d-none');
            } else {
                $(`#${e.target.dataset.otro}`).addClass('d-none');
            }
        }
    }

    change_value_show_otro(e) {
        let value = e.target.value;
        if (e.target.dataset.hasOwnProperty('otro')) {
            const $select = $(`#${e.target.dataset.otro}`);
            const $option = $select.find('option:selected');
            if ($option.length) {
                if (value !== '') {
                    $option.val(`Otros (${value})`);
                } else {
                    $option.val('Otros');
                }
            }
        }
    }

    show_otro_multiple(e) {
        // e.target es el select múltiple
        const selectedOptions = Array.from(e.target.selectedOptions).map(opt => opt.value);
        if (e.target.dataset.hasOwnProperty('otro')) {
            const $input = $(`#${e.target.dataset.otro}`);
            const $select = $(e.target);
            const $optionOtros = $select.find('option').filter(function() { return $(this).val() === 'Otros'; });
            if (selectedOptions.includes('Otros')) {
                $input.removeClass('d-none');
            } else {
                $input.addClass('d-none');
                $input.val('');
                $optionOtros.text('Otros'); // Restaurar texto
            }
        }
    }

    change_value_show_otro_multiple(e) {
        // e.target es el input de texto para "Otros"
        const value = e.target.value;
        const selectId = e.target.dataset.otro;
        const $select = $(`#${selectId}`);

        // Buscar la opción "Otros"
        const $option = $select.find('option').filter(function() { return $(this).val() === 'Otros'; });
        if ($option.length) {
            if (value !== '') {
                $option.val(`Otros (${value})`);
            } else {
                $option.val('Otros');
            }
        }
    }
}